import { useState } from "react";
import { Link } from "react-router";
import translations from '../locales/translations.json';

function t(key) {
  return translations[key] || key;
}

function Element({ setUser, apiCall, setCookie, setToken, addSuccess }) {
    const [email, setEmail] = useState("");
    const [password, setPassword] = useState("");
    const [error, setError] = useState(null);

    // send data to API on form submit
    const handleSubmit = async (e) => {
        e.preventDefault();
        setError(null);

        const { response, error } = await apiCall("POST", "login", { email, password });

        if (error) {
            setError(t('login_failed'));
            return;
        }

        if (response && response.user) {
            setCookie('token', response.token, { path: '/' });
            //setCookie('user', response.user, { path: '/' });
            setUser(response.user);
            setToken(response.token);
            
            if (response.user.role_id === 3) {
                window.location.href = '/transport'; // Redirect to transport page for transport role
            } else if (response.user.role_id === 2) {
                window.location.href = '/add'; // Redirect to add report page for hunters
            } else {
                window.location.href = '/';
            }

        } else {
            setError(t('login_failed'));
        }

    };


    return (
        <div className="row m-0">
            <div className="col-12 p-0">
                <div className="login-card login-dark">
                    <div className="login-main">
                        {addSuccess && <div className="alert alert-success">Viltet med Id {addSuccess} är nu registrerat</div>}
                        <form className="theme-form" onSubmit={(e) => handleSubmit(e)}>
                            <h4>{t('sign_in_to_account')}</h4>
                            <p>{t('enter_email_password')}</p>
                            <div className="form-group">
                                <label className="col-form-label">{t('email_address')}</label>
                                <input className="form-control" type="email" required placeholder={t('email_placeholder')} value={email} onChange={(e) => setEmail(e.target.value)} />

                            </div>
                            <div className="form-group">
                                <label className="col-form-label">{t('password')}</label>
                                <div className="form-input position-relative">
                                    <input className="form-control" type="password" name="login[password]" value={password} onChange={(e) => setPassword(e.target.value)} required placeholder={t('password_placeholder')} />
                                </div>
                            </div>
                            <div className="form-group mb-0">
                                <div className="form-check">
                                    <input className="checkbox-primary form-check-input" id="checkbox1" type="checkbox" />
                                    <label className="text-muted form-check-label" htmlFor="checkbox1">{t('remember_password')}</label>
                                </div><Link className="link" to="/forgot">{t('forgot_password_link')}</Link>
                                {error && <div className="alert alert-danger mt-2">{error}</div>}
                                <div className="clearfix"></div>
                                <div className="text-end">
                                    <button className="btn btn-primary btn-block w-100 mt-3" type="submit">{t('sign_in')}</button>
                                </div>
                            </div>

                            <p className="mt-4 mb-0 text-center">{t('dont_have_account')}<Link className="ms-2" to="/register">{t('create_account')}</Link></p>
                        </form>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default Element;
